// Shared constants for the Djayma e-commerce application

// Brand names — single source of truth.
// Djayma = e-commerce platform. Yoboulmako = delivery partner (visible to customers).
export const BRAND_PLATFORM = "Djayma";
export const BRAND_DELIVERY = "Yoboulmako";
export const BRAND_COBRAND = `${BRAND_PLATFORM} × ${BRAND_DELIVERY}`;

export const DJAYMA_PHONE = "+221 76 604 22 74";
export const DJAYMA_PHONE_TEL = "tel:+221766042274";
export const DJAYMA_WHATSAPP = "https://wa.me/221766042274";
export const DJAYMA_EMAIL = "contact@djayma.com";

export const REGIONS = [
  { id: "dakar", label: "Dakar" },
  { id: "thies-mbour", label: "Thiès-Mbour" },
  { id: "kaolack", label: "Kaolack" },
  { id: "saint-louis", label: "Saint-Louis" },
  { id: "fatick", label: "Fatick" },
  { id: "diourbel-touba", label: "Diourbel-Touba" },
] as const;

export type RegionId = (typeof REGIONS)[number]["id"];

export const NAV_LINKS = [
  { labelKey: "all_products", href: "#catalog" },
  { labelKey: "contact", href: "/contact" },
] as const;
